<template>
  <div>
   
    <v-container
    id="allresearches"
    fluid
    tag="section"
  >
    <v-row>

      <!-- SEARCH FOR USER -->

      <!-- <v-col cols="12" sm="12" md="6" xl='6'>
        <v-card class="px-5 py-4">
          <v-row>
                <v-sheet
                  color="primary"
                  max-height="50"
                  class="pa-12"
                  dark
                  top
                  id="searchsheet"
                  rounded
                  elevation='6'
                >
                <div class='headingsheet2'>
                  <v-icon id="sheeticon" :light="this.$vuetify.theme.dark ? true : false"  large>mdi-magnify</v-icon>
                  </div>
                </v-sheet>
                       <v-row class="searchrow">
                      <v-text-field
                          label="Search in all collections"
                          append-outer-icon="mdi-magnify"
                          :error-messages="keywordErrors"
                          v-model="keyword"
                          class='longcol'
                          @input="$v.keyword.$touch()"
                          v-on:keyup.enter="searchKeywords"
                          @click:append-outer="searchKeywords"
                          clearable
                        />
                   
                       </v-row>
                </v-row>
        </v-card>
      </v-col> -->
      <v-col cols="12" sm="6" md="3" xl='3'>
        <v-card class="px-5 py-3" id="kwcountCard">
          <v-row>
                <v-sheet
                  color="primary"
                  max-height="50"
                  class="pa-12"
                  dark
                  top
                  id="searchsheet"
                  rounded
                  elevation='6'
                >
                <div class='headingsheet2'>
                  <v-icon id="sheeticon" :light="this.$vuetify.theme.dark ? true : false"   large>mdi-account</v-icon>
                </div>
                </v-sheet>
            <div class="ml-auto text-right">
              <div class="body-3 grey--text font-weight-light">  Registered User </div>
              <div > {{userCount}} </div>
            </div>
          </v-row>
            <v-col cols="12" class="px-0 pb-1">
              <v-divider />
            </v-col>
            <v-icon  size="16" class="ml-2 mr-1">
              mdi-clock
            </v-icon>
           <span class="caption grey--text font-weight-light" > Updated on {{updatedDate}}</span>
        </v-card>
      </v-col>
       <v-col cols="12" sm="6" md="3" xl='63'>
        <v-card class="px-5 py-3" id="kwcountCard">
          <v-row>
                <v-sheet
                  color="primary"
                  max-height="50"
                  class="pa-12"
                  dark
                  top
                  id="searchsheet"
                  rounded
                  elevation='6'
                >
                <div class='headingsheet2'>
                  <v-icon id="sheeticon" :light="this.$vuetify.theme.dark ? true : false"   large>mdi-database</v-icon>
                </div>
                </v-sheet>
            <div class="ml-auto text-right">
              <div class="body-3 grey--text font-weight-light">  Databases </div>
              <div > {{dbCount}} </div>
            </div>
          </v-row>
            <v-col cols="12" class="px-0 pb-1">
              <v-divider />
            </v-col>
            <v-icon  size="16" class="ml-2 mr-1">
              mdi-clock
            </v-icon>
           <span class="caption grey--text font-weight-light" > Updated on {{updatedDate}}</span>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3" xl='63'>
        <v-card class="px-5 py-3" id="kwcountCard">
          <v-row>
                <v-sheet
                  color="primary"
                  max-height="50"
                  class="pa-12"
                  dark
                  top
                  id="searchsheet"
                  rounded
                  elevation='6'
                >
                <div class='headingsheet2'>
                  <v-icon id="sheeticon" :light="this.$vuetify.theme.dark ? true : false"   large>mdi-source-pull</v-icon>
                </div>
                </v-sheet>
            <div class="ml-auto text-right">
              <div class="body-3 grey--text font-weight-light"> DataForSEO Requests </div>
              <div > {{requestsCount}} </div>
            </div>
          </v-row>
            <v-col cols="12" class="px-0 pb-1">
              <v-divider />
            </v-col>
            <v-icon  size="16" class="ml-2 mr-1">
              mdi-clock
            </v-icon>
           <span class="caption grey--text font-weight-light" > Updated on {{updatedDate}}</span>
        </v-card>
      </v-col>
      
       <v-col cols="12" sm="6" md="3" xl='63'>
        <v-card class="px-5 py-3" id="kwcountCard">
          <v-row>
                <v-sheet
                  color="primary"
                  max-height="50"
                  class="pa-12"
                  dark
                  top
                  id="searchsheet"
                  rounded
                  elevation='6'
                >
                <div class='headingsheet2'>
                  <v-icon id="sheeticon" :light="this.$vuetify.theme.dark ? true : false"   large>mdi-database</v-icon>
                </div>
                </v-sheet>
            <div class="ml-auto text-right">
              <div class="body-3 grey--text font-weight-light">  Keywords </div>
              <div > {{collectionCount}} </div>
            </div>
          </v-row>
            <v-col cols="12" class="px-0 pb-1">
              <v-divider />
            </v-col>
            <v-icon  size="16" class="ml-2 mr-1">
              mdi-clock
            </v-icon>
           <span class="caption grey--text font-weight-light" > Updated on {{updatedDate}}</span>
        </v-card>
      </v-col>
    </v-row>
  

  </v-container>
  </div>
</template>

<script>



  export default {
    name: 'AdminMonitoring',
 

    data: () => ({
      userCount: undefined,
      requestsCount: undefined,
      dbCount: undefined,
      auth: "Basic " + window.btoa(process.env.VUE_APP_AUTH),
    }),
    computed: {
      
      keywordErrors () {
        const errors = []
        if (!this.$v.keyword.$dirty) return errors
        !this.$v.keyword.maxLength && errors.push('Keyword must be at most 30 characters long.')
        !this.$v.keyword.required && errors.push('This field is required.')

        return errors
      }
    },
    methods: {
    
      fetchStats() {
        this.$http.get(process.env.VUE_APP_APIURL+'/admin/monitoring/stats', { headers: {'Authorization': this.auth}})
          .then(function(response){
            console.log(response)
            this.userCount = response.body.userCount
            this.requestsCount = response.body.requestsCount
            this.dbCount = response.body.dbCount
          //   let stats = {};
          //   this.collectionCount= response.body.stats.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "."); 
          //   this.collectionSize = (response.body.stats.storageSize/1014).toFixed(2) + " MB";
          });
      },
    
    
    },
    created: function(){
    
      this.fetchStats();

    },
  }
</script>
<style lang="css" scoped>
.illustration{
  margin-top: 7% !important;
  margin-left: 15%;
}
.chooseMainCard{
  background-color: rgb(243, 243, 243);
  overflow-x: hidden;
}
.avat{
  width: 100px;
  height: 100px;
  background-color: var(--v-primary-base);
  border-radius: 50%;
  margin-top: 10px !important;
  margin-left: 5%;
}
.chooseCard{
  width: 450px;
  height: 200px;
  background-color: white;
  border-radius: 5px;
  cursor: pointer;
}
.chooseCard:hover{
  border: 2px solid var(--v-primary-base);
  box-shadow: 6px 4px 4px #cecece;
}
#sparkline{
 max-width: 140px;
}
#kwsearch{
  margin-right: 20px !important;
}
#heading3{
  font-weight: 300!important;
  color: rgb(105, 105, 105);
}
.headingsheet{
  margin-top: -15px;
}
.headingsheet2{
  margin-top: -15px;
}
#searchsheet{
  margin-top: -30px;
  margin-left:5px;
  width: 30px;
  height: 30px;
}
#tablesheet{
  margin-left:5px;
  margin-top: -30px;
  width: 60px;
  height: 60px;
}
.rounded-card{
margin-top: 30px;
/* padding-left: 0px !important;
padding-right: 0px !important; */
}
#sheeticon{
    margin-left: -25px;
    margin-top: -25px;
    margin: auto !important;
    padding-bottom: 50% !important;
    width: 50% !important;
}
.shortcol{
  max-width: 20% !important;
}
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
.v-card__text{
  padding: 0px !important;
}
.v-card__title {
    padding-top:  0px;
}
#kwcountCard{
  padding-bottom: 10px !important;
}
.v-application .pa-12 {
    padding: 50px !important;
}
.searchrow{
margin:15px;
}
#allresearches{
    padding-top: 30px;
    margin-top: -10px;
}
#listnameColumn{
  font-size: 1.1em;
}
</style>


